export default __webpack_public_path__ + "static/media/question-mark.9540c9ef.svg";